import { configureStore } from "@reduxjs/toolkit";
import tokenReducer from "./slice/index";

export const store = configureStore({
  reducer: {
    tokenStore: tokenReducer,
  },
});
